// Text-date conversions for Required Fields (2026-10-21, built for Egnyte Just:
// the supplier sends Start/End Date as DD-MM-YYYY text, the client wants M/D/YY).
// Stored as required_fields config_json.field_date_formats = {field_key: {from, to}}
// and applied when a supplier's upload becomes leads. Backend half:
// app/utils/date_convert.py (same format names).

export const DATE_CONVERSION_PRESETS = [
  { value: 'DD-MM-YYYY>M/D/YY',     label: 'DD-MM-YYYY → M/D/YY' },
  { value: 'DD/MM/YYYY>M/D/YY',     label: 'DD/MM/YYYY → M/D/YY' },
  { value: 'DD-MM-YYYY>MM/DD/YYYY', label: 'DD-MM-YYYY → MM/DD/YYYY' },
  { value: 'DD/MM/YYYY>MM/DD/YYYY', label: 'DD/MM/YYYY → MM/DD/YYYY' },
  { value: 'MM/DD/YYYY>M/D/YY',     label: 'MM/DD/YYYY → M/D/YY' },
];

// {from, to} -> select value ('' when nothing is set).
export function conversionToValue(spec) {
  return spec && spec.from && spec.to ? `${spec.from}>${spec.to}` : '';
}

// select value -> {from, to}, or null for "as sent".
export function valueToConversion(value) {
  const parts = String(value || '').split('>');
  return parts.length === 2 && parts[0] && parts[1] ? { from: parts[0], to: parts[1] } : null;
}

// Options for one field's select: the presets, plus the field's current setting
// when it is not one of them (set through the API), so showing it never changes it.
export function conversionOptions(spec) {
  const current = conversionToValue(spec);
  const options = [{ value: '', label: 'Date: as sent' }, ...DATE_CONVERSION_PRESETS];
  if (current && !options.some(o => o.value === current)) {
    options.push({ value: current, label: `${spec.from} → ${spec.to}` });
  }
  return options;
}

// A field row shows the control for text-like custom fields and for any field
// that already has a conversion, so an existing one is never hidden.
export function showsDateConversion(fieldKey, spec) {
  return String(fieldKey).startsWith('custom_field_') || !!conversionToValue(spec);
}
